import router from './index'
import { getToken } from '@/utils/auth'
// import { reloadLogin } from '@/api/api-bladex';
// import initYCKFSSOLogin from '@/api/ssoLogin'
let reloadLoginTimer = null
let routeAdded = false
function addRoute() {
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  // console.log("添加动态路由")
  if (!userinfo || !userinfo.authorities) return;
  userinfo.authorities.forEach(item => {
    item.children.forEach(menu => {
      router.addRoute('layout', {
        path: menu.accessUrl,
        name: menu.accessUrl,
        component: () => import('@/views' + menu.component)
      })
    })
  })
}

const whiteList = ['/login', '/404'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  reloadLoginTimer = null

  // 盐城单点登录
  // initYCKFSSOLogin()
  
// to.path.indexOf('/sso') === 0

const customized_list = ['electronicFence','technologicalProcess','map']
const isPath = customized_list.some(pathName => to.path.indexOf(pathName) === 0)
console.log(isPath,'isPathisPathisPathisPath') 
// to.path.indexOf('/technologicalProcess') === 0 || to.path.indexOf('/electronicFence') === 0
  if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('/v') === 0 || to.path.indexOf('/report-v') === 0 || to.path.indexOf('/mobile/') === 0 || to.path.indexOf('/technologicalProcess') === 0 || to.path.indexOf('/electronicFence') === 0) {
    if (to.path === '/login') {
      setTitle()
      localStorage.removeItem('token');
      localStorage.removeItem('userinfo');
    }
    next()
  } else {
    setTitle()


    const hasToken = getToken()
    if (hasToken) {
      if (!routeAdded) {
        routeAdded = true;
        addRoute();//解决刷新页面动态路由失效
        router.replace(to.fullPath).then()
      } else {
        next()
      }
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  const singleSignOn = JSON.parse(JSON.stringify(sessionStorage.getItem('singleSignOn') || {}))
  // console.log(typeof singleSignOn, 'singleSignOn')
  // let time = 1000 * (60 * 5)
  let time = 10000
  // console.log('?')
  // reloadLoginTimer = setInterval(() => {
  // console.log(  '??')
  // reloadLogin().then(res => {
  //   console.log(res)
  // })
  // }, time)
})



const setTitle = () => {
  document.title = '大数据平台'
}
